import DetailsAnchor from '../components/detailsAnchor';
import SchedulerAnchor from '../components/schedulerAnchor';
import PhoneAnchor from '../components/phoneAnchor';
import PhoneAnchorCallTracking from '../components/phoneAnchorCallTracking';
import CreateAccountAnchor from '../components/createAccountAnchor';
import ReturnToSearchAnchor from '../components/returnToSearchAnchor';

/**
 * Returns a contact builder anchor element based on the modal information and listing information provided.
 * @param {Object} modalInformation - The modal information object.
 * @param {string} modalInformation.url - The URL for the listing's detail page.
 * @param {Object} modalInformation.listingInformation - The listing information object.
 * @param {string} modalInformation.listingInformation.schedulerUrl -The scheduler URL.
 * @param {string} modalInformation.listingInformation.phoneNumber The phone number.
 * @param {boolean} modalInformation.listingInformation.hasCallTracking if the phone number has call tracking.
 * @returns {Object} - The anchor element.
 */
function getContactBuilderAnchor(modalInformation) {
  const { url, listingInformation } = modalInformation;
  const { schedulerUrl, phoneNumber, hasCallTracking } = listingInformation;
  const anchors = [];

  // instantiate all the possible anchor elements and add them to the anchors list
  if (schedulerUrl) {
    const schedulerAnchor = new SchedulerAnchor();
    schedulerAnchor.setUrl(schedulerUrl);
    anchors.push({ anchor: schedulerAnchor, condition: true });
  }

  if (phoneNumber && hasCallTracking === 'True') {
    const phoneCallTrackingAnchor = new PhoneAnchorCallTracking();
    phoneCallTrackingAnchor.setPhoneNumber(phoneNumber);
    anchors.push({ anchor: phoneCallTrackingAnchor, condition: true });
  }

  if (phoneNumber) {
    const phoneAnchor = new PhoneAnchor();
    phoneAnchor.setPhoneNumber(phoneNumber);
    anchors.push({ anchor: phoneAnchor, condition: true });
  }

  // always instantiate the details anchor.
  const detailAnchor = new DetailsAnchor();
  detailAnchor.setUrl(url);
  detailAnchor.setListingId(listingInformation.id);
  detailAnchor.setListingType(listingInformation.type);
  anchors.push({ anchor: detailAnchor, condition: true });

  // Find the first anchor that has a true condition.
  return anchors.find(({ condition }) => condition)?.anchor;
}

/**
 * Returns an anchor element based on the user logged status.
 * @param {boolean} isLoggedIn if the user is logged in.
 * @returns {Object} - The anchor element.
 */
function getInternalBrowsingAnchor(isLoggedIn) {
  if (isLoggedIn) {
    return new ReturnToSearchAnchor();
  }
  return new CreateAccountAnchor();
}

export { getContactBuilderAnchor, getInternalBrowsingAnchor };
